import { FC, Fragment } from "react";
import React from "react";
import { makeStyles, createStyles, FormControl, Grid } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Checkbox } from "../core/Checkbox";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        containerError: {
            backgroundColor: Colors.radiantRedFill,
            borderColor: Colors.radiantRed,
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: 8,
        },
        formControlLabelStyle: {
            marginRight: 110,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const NewConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrameForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_PROVIDED_INSTALLATION_FRAME
    >();
    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <div className={classes.container} style={{ marginBottom: 16 }}>
                <FormControl
                    component="fieldset"
                    className={classes.container}
                    style={{ display: "flex" }}
                >
                    <Grid container spacing={7} className={formControlClasses.container}>
                        <Grid item>
                            <FormControlLabel
                                isCheckBox={true}
                                className={formControlClasses.formControlLabelStyle}
                                control={
                                    <Checkbox
                                        className={formControlClasses.checkboxStyle}
                                        value="power"
                                        checked={
                                            values
                                                .newConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrame
                                                .value.yes
                                        }
                                        onChange={(event, checked) => {
                                            setValues(values => {
                                                values.newConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrame.value.yes = checked;
                                                values.newConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrame.value.no = !checked;
                                            });
                                        }}
                                    />
                                }
                                label="Bodenplattendurchdringung"
                                sublabel="Die Bodenplattendurchdringung <b>muss</b> in Eigenleistung ausgeführt werden"
                                text="Das Rohbauteil mit biegesteifen Rohren wird vorab geliefert und muss bauseits in die Bodenplatte eingegossen werden"
                                error={
                                    values
                                        .newConnectionMultilinePersonalContributionMustInfuseProvidedInstallationFrame
                                        .error !== null
                                }
                            />
                        </Grid>
                    </Grid>
                </FormControl>
            </div>
        </Fragment>
    );
};
